
export default {
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      activeIndex: 0,
      carouselOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      carousel: null,
    };
  },
  computed: {
    slides () {
      return this.block.slides;
    },
    sliderName () {
      if (this.block.title) {
        return `carousel-${this.slugify(this.block.title)}`;
      }
      return `carousel-${Math.floor(Math.random() * 1000)}`;
    },
  },
  methods: {
    nextSlide () {
      this.carousel.slideNext(500);
    },
    prevSlide () {
      this.carousel.slidePrev(500);
    },
    slideChange (index) {
      this.activeIndex = index;
    },
    getImageSrc (slide) {
      return slide.image.sizes[`1536x1536`] || slide.image.sizes[`post-thumbnail`];
    },
  },
};
